import { Component, OnInit, OnDestroy, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { SharedService } from '../../../shared/services/shared-service.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';

@Component({
  selector: 'app-overview-container',
  templateUrl: './overview-container.component.html',
  styleUrls: ['./overview-container.component.scss']
})
export class OverviewContainerComponent implements OnInit, OnDestroy {

  private _bookingInitSubscription: Subscription;
  private _challengeShopperSubscription: Subscription;
  private _routeSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _flyBackStateSubscription: Subscription;

  public classVal: string = 'is-closed';
  public isFlyback: boolean = false;
  public showOverview = false;
  public currentRoute = '';
  public bookingType = '';
  public bookingInit: Boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _sharedService: SharedService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.currentRoute = window.location.pathname.split('/')[1];
      this.handleOverviewSection();

      this._routeSubscription = this._router.events.subscribe(event => {
        console.log('routing', event);
        if (event instanceof NavigationStart) {
          this.currentRoute = event.url.split('/')[1];
          this.handleOverviewSection();
        }

      });

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.bookingInit = res.currentBookingLoaded;

          if (this.bookingInit) {
            this.setDataSubscriptions();
          }

        });

      this._challengeShopperSubscription = this._sharedService.challengeShopperSubject$.subscribe(challengeActive => {
        this.showOverview = !challengeActive;
      });

    }

    this._flyBackStateSubscription = this._appStore.select('flybackReducer')
      .subscribe((res: any) => {
        this.isFlyback = res.flybackBooking;
        if (this.isFlyback) {
          this.classVal = 'is-open';
        } else {
          this.classVal = 'is-closed';
        }
      });

  }

  setDataSubscriptions() {

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe(bookingState => {
        this.bookingType = bookingState.bookingDetails.bookingType;
        this.handleOverviewSection();
      });
  }

  handleOverviewSection() {
    if (
      (this.currentRoute === 'abc' || this.currentRoute === 'ccd') && this.bookingType !== 'amend') {
      this.showOverview = true;
    } else {
      this.showOverview = false;
    }
  }

  ngOnDestroy() {

    if (isPlatformBrowser(this.platformId)) {
      if (this._routeSubscription) { this._routeSubscription.unsubscribe() };

      if (this._challengeShopperSubscription) {
        this._challengeShopperSubscription.unsubscribe();
      }

      if (this._bookingStateSubscription) {
        this._bookingStateSubscription.unsubscribe();
      }

      if (this._bookingInitSubscription) {
        this._bookingInitSubscription.unsubscribe();
      }
    }

    this._flyBackStateSubscription.unsubscribe();
  }

}
